import { FormControl } from "@angular/forms";

export interface PaymentMethod {
    nameOnCard: string;
    cardNumber: string;
    expDate: string;
    cvc: string;
    // billingAddress: string;
    // billiingCity: string;
    // billingState: string;
    // billingZip: string;
    // country: string;
    saveCard: boolean;
    autoRenew: boolean;
};

export interface PaymentMethodForm {
    nameOnCard: FormControl<string>;
    cardNumber: FormControl<string>;
    expDate: FormControl<string>;
    cvc: FormControl<string>;
    // billingAddress: FormControl<string>;
    // billiingCity: FormControl<string>;
    // billingState: FormControl<string>;
    // billingZip: FormControl<string>;
    // country: FormControl<string>;
    saveCard: FormControl<boolean>;
    autoRenew: FormControl<boolean>;
};